import { useEffect } from "react";
import { trackWhatsApp, trackPhone } from "@/lib/analytics";

/**
 * Global click delegation: fires GA4 events for every WhatsApp / phone
 * CTA on the site, regardless of where it's defined. Mount once at app root.
 */
export default function AnalyticsTracker() {
  useEffect(() => {
    const onClick = (e) => {
      const a = e.target.closest && e.target.closest("a[href]");
      if (!a) return;
      const href = a.getAttribute("href") || "";
      const text = (a.innerText || a.getAttribute("aria-label") || "").trim().slice(0, 80);
      const page_path = window.location.pathname + window.location.search;

      if (href.startsWith("https://wa.me/") || href.startsWith("http://wa.me/")) {
        trackWhatsApp({ link_url: href, link_text: text, page_path });
      } else if (href.startsWith("tel:")) {
        trackPhone({ link_url: href, page_path });
      }
    };

    document.addEventListener("click", onClick, true);
    return () => document.removeEventListener("click", onClick, true);
  }, []);

  return null;
}
